(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sender-commerce-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sender-action-hero')) {
  class SenderActionHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-play-label]');
      if (!this.video || !this.button) return;
      this.video.id = this.button.getAttribute('aria-controls');
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.connection = navigator.connection;
      this.userPaused = false;
      this.manualPlay = false;
      this.inView = true;
      this.sourceKey = null;
      this.playPending = false;
      this.failed = false;
      this.button.hidden = false;
      this.video.addEventListener('playing', () => {
        if (!this.canPlay()) {
          this.video.pause();
          return;
        }
        this.setAttribute('data-frame-ready', '');
        this.dataset.playback = 'playing';
        this.button.setAttribute('aria-label', this.button.dataset.pauseLabel);
      }, options);
      this.video.addEventListener('pause', () => this.setPaused(), options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.setPaused();
        this.removeAttribute('data-frame-ready');
        this.button.hidden = true;
      }, options);
      this.button.addEventListener('click', () => {
        if (!this.video.paused) {
          this.userPaused = true;
          this.manualPlay = false;
          this.video.pause();
        } else {
          this.userPaused = false;
          this.manualPlay = true;
          this.sync();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reduced.addEventListener('change', () => {
        this.manualPlay = false;
        this.sync();
      }, options);
      this.mobile.addEventListener('change', () => this.sync(), options);
      if (this.connection && typeof this.connection.addEventListener === 'function') {
        this.connection.addEventListener('change', () => this.sync(), options);
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: .05 });
        this.observer.observe(this);
      }
      this.sync();
    }
    setPaused() {
      this.dataset.playback = 'paused';
      this.button.setAttribute('aria-label', this.button.dataset.playLabel);
    }
    canPlay() {
      const constrained = this.reduced.matches || Boolean(this.connection && this.connection.saveData);
      return !this.failed && !this.userPaused && !document.hidden && this.inView && (!constrained || this.manualPlay);
    }
    sync() {
      if (!this.isConnected || !this.video) return;
      if (!this.canPlay()) {
        this.video.pause();
        this.setPaused();
        return;
      }
      let key = this.mobile.matches ? 'mobile' : 'desktop';
      let template = this.querySelector(`[data-action-${key}]`);
      if (!template || !template.content.querySelector('source')) {
        key = 'desktop';
        template = this.querySelector('[data-action-desktop]');
      }
      if (!template || !template.content.querySelector('source')) {
        this.button.hidden = true;
        return;
      }
      if (key !== this.sourceKey) {
        this.video.pause();
        this.removeAttribute('data-frame-ready');
        this.video.replaceChildren(template.content.cloneNode(true));
        this.sourceKey = key;
        this.video.load();
      }
      if (!this.video.paused || this.playPending) return;
      this.playPending = true;
      this.video.play().catch(() => {
        if (this.isConnected) this.setPaused();
      }).finally(() => {
        this.playPending = false;
      });
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.observer) this.observer.disconnect();
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.replaceChildren();
        this.video.load();
      }
    }
  }
  customElements.define('sender-action-hero', SenderActionHero);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sender-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sender-customer-reviews')) {
    customElements.define('sender-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        this.enhance = () => {
          const arrows = this.querySelectorAll('.jdgm-arrow');
          arrows.forEach((button, index) => button.setAttribute('aria-label', index === 0 ? this.dataset.previousLabel : this.dataset.nextLabel));
          this.querySelectorAll('.jdgm-card').forEach(card => {
            if (card.dataset.cloneType) {
              card.setAttribute('aria-hidden', 'true');
              card.setAttribute('tabindex', '-1');
              return;
            }
            card.setAttribute('role', 'button');
            card.setAttribute('tabindex', '0');
            const name = card.querySelector('.jdgm-reviewer-name')?.textContent?.trim() || '';
            card.setAttribute('aria-label', this.dataset.openLabel.replace('[name]', name));
          });
        };
        this.onKey = event => {
          const card = event.target.closest('.jdgm-card');
          if (card && event.target === card && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            card.click();
          }
        };
        this.addEventListener('keydown', this.onKey);
        this.observer = new MutationObserver(this.enhance);
        this.observer.observe(this, {childList: true, subtree: true});
        this.enhance();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('keydown', this.onKey);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sender-launch-campaign"] && !Shopify.designMode) return;
  try {
    
  class SenderCampaignVideo {
    constructor(section) {
      this.section = section;
      this.video = section.querySelector('video');
      this.button = section.querySelector('.sender-campaign__video-toggle');
      this.inView = false;
      this.userPaused = false;
      this.manualPlay = false;
      this.failed = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.saveData = Boolean(navigator.connection && navigator.connection.saveData);
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video.addEventListener('playing', () => {
        section.classList.add('sender-campaign--video-active');
        this.updateButton();
      }, options);
      this.video.addEventListener('pause', () => this.updateButton(), options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        section.classList.remove('sender-campaign--video-active');
        this.button.hidden = true;
      }, options);
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.manualPlay = true;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.12 });
      this.observer.observe(section);
    }
    updateButton() {
      const playing = !this.video.paused;
      this.button.setAttribute('aria-pressed', String(playing));
      this.button.querySelector('span').textContent = playing ? this.button.dataset.pause : this.button.dataset.play;
    }
    play() {
      if (this.failed) return;
      this.video.muted = true;
      const promise = this.video.play();
      if (promise) promise.catch(() => this.updateButton());
    }
    sync() {
      const allowed = this.manualPlay || (!this.motion.matches && !this.saveData);
      if (this.inView && !document.hidden && !this.userPaused && allowed) this.play();
      else this.video.pause();
    }
    destroy() {
      this.observer.disconnect();
      this.video.pause();
      this.abort.abort();
    }
  }
  const senderCampaignInstances = new WeakMap();
  const initSenderCampaign = root => {
    root.querySelectorAll('[data-campaign-video]').forEach(section => {
      if (!senderCampaignInstances.has(section)) senderCampaignInstances.set(section, new SenderCampaignVideo(section));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initSenderCampaign(document), { once: true });
  else initSenderCampaign(document);
  document.addEventListener('shopify:section:load', event => initSenderCampaign(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-campaign-video]').forEach(section => {
      const instance = senderCampaignInstances.get(section);
      if (instance) instance.destroy();
      senderCampaignInstances.delete(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sender-story-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sender-story-stats')) {
  customElements.define('sender-story-stats', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.setup(); });
    }

    setup() {
      this.observer?.disconnect();
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.controller = new AbortController();
      this.entries = [];
      const locale = document.documentElement.lang || 'de';
      const separator = new Intl.NumberFormat(locale).formatToParts(1.1).find(part => part.type === 'decimal')?.value || '.';
      this.querySelectorAll('[data-count-target]').forEach(node => {
        const original = node.dataset.countTarget;
        node.textContent = original;
        const parts = original.trim().split(separator);
        if (parts.length > 2 || !parts.every(part => /^\d+$/.test(part))) return;
        const decimals = parts[1]?.length || 0;
        const value = Number(parts.join('.'));
        if (!Number.isFinite(value) || value <= 0 || value > 1000000000 || decimals > 4) return;
        const format = new Intl.NumberFormat(locale, {useGrouping: false, minimumFractionDigits: decimals, maximumFractionDigits: decimals});
        this.entries.push({node, original, value, decimals, format});
      });
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.played || this.dataset.animate !== 'true' || this.motion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window) || !this.entries.length) {
        this.finish();
        return;
      }
      const signal = this.controller.signal;
      this.motion.addEventListener('change', event => { if (event.matches) this.finish(); }, {signal});
      document.addEventListener('visibilitychange', () => { if (document.hidden && this.played) this.finish(); }, {signal});
      window.addEventListener('pagehide', () => this.finish(), {signal});
      this.dataset.countState = 'waiting';
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .4)) this.start();
      }, {threshold: .4});
      this.observer.observe(this);
    }

    start() {
      if (this.played) return;
      this.played = true;
      this.observer?.disconnect();
      this.dataset.countState = 'running';
      const started = performance.now();
      this.entries.forEach(entry => { entry.node.textContent = entry.format.format(0); });
      const tick = now => {
        const progress = Math.max(0, Math.min(1, (now - started) / 1000));
        if (progress >= 1) { this.finish(); return; }
        const eased = 1 - Math.pow(1 - progress, 3);
        this.entries.forEach(entry => {
          const factor = Math.pow(10, entry.decimals);
          const current = Math.floor(entry.value * eased * factor) / factor;
          entry.node.textContent = entry.format.format(current);
        });
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    finish() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.entries?.forEach(entry => { entry.node.textContent = entry.original; });
      this.played = true;
      this.dataset.countState = 'complete';
      this.controller?.abort();
    }

    disconnectedCallback() {
      if (this.played) this.finish();
      this.observer?.disconnect();
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sender-story-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sender-story-header-promo')) customElements.define('sender-story-header-promo', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    clearInterval(this.timer);
    this.controller = new AbortController();
    this.counter = this.querySelector('[data-uhr]');
    this.caption = this.querySelector('[data-deadline-label]');
    this.text = this.querySelector('[data-promo-text]');
    if (!this.counter || !this.caption || !this.text) return;
    this.digits = ['std', 'min', 'sek'].map(key => this.counter.querySelector('[data-' + key + ']'));
    if (this.digits.some(digit => !digit)) return;
    this.originalText ??= this.text.textContent;
    this.text.textContent = this.originalText;
    this.daily = this.dataset.mode === 'daily';
    this.zone = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Berlin', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'});
    this.dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'de', {timeZone:'Europe/Berlin', day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit', hourCycle:'h23'});
    this.deadline = this.daily ? this.nextMidnight(Date.now()) : Date.parse(this.dataset.deadline);
    this.caption.removeAttribute('datetime');
    this.tick = () => {
      const now = Date.now();
      if (this.daily && now >= this.deadline) this.deadline = this.nextMidnight(now);
      if (!Number.isFinite(this.deadline)) {
        this.counter.hidden = true;
        this.caption.hidden = true;
        clearInterval(this.timer);
        return;
      }
      const left = Math.max(0, Math.ceil((this.deadline - now) / 1000));
      if (!left) {
        this.counter.hidden = true;
        this.caption.hidden = true;
        this.text.textContent = this.dataset.expired || this.originalText;
        clearInterval(this.timer);
        return;
      }
      this.counter.hidden = false;
      this.caption.hidden = this.dataset.showDeadline !== 'true';
      const values = [Math.floor(left / 3600), Math.floor(left / 60) % 60, left % 60];
      this.digits.forEach((digit, index) => { digit.textContent = String(values[index]).padStart(2, '0'); });
      const iso = new Date(this.deadline).toISOString();
      if (this.caption.dateTime !== iso) {
        this.caption.dateTime = iso;
        this.caption.textContent = [this.caption.dataset.label, this.dateFormat.format(this.deadline)].filter(Boolean).join(' ');
      }
    };
    if (Number.isFinite(this.deadline)) this.timer = setInterval(this.tick, 1000);
    this.tick();
    document.addEventListener('visibilitychange', this.tick, {signal:this.controller.signal});
    window.addEventListener('pageshow', this.tick, {signal:this.controller.signal});
  }
  parts(time) {
    return Object.fromEntries(this.zone.formatToParts(time).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  }
  nextMidnight(now) {
    const date = this.parts(now);
    const target = Date.UTC(date.year, date.month - 1, date.day + 1);
    let result = target;
    for (let index = 0; index < 4; index++) {
      const local = this.parts(result);
      const correction = target - Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
      result += correction;
      if (correction === 0) break;
    }
    return result;
  }
  disconnectedCallback() {
    clearInterval(this.timer);
    this.controller?.abort();
  }
});
if (!window.senderStoryCartLink) {
  window.senderStoryCartLink = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-story-cart]');
    const drawer = document.querySelector('cart-drawer');
    if (!link || !drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(link);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sender-story-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sender-story-product')) {
  customElements.define('sender-story-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.variant = this.form.querySelector('[name="id"]');
      this.offers = [...this.form.querySelectorAll('[name="quantity"]')];
      this.button = this.form.querySelector('[type="submit"]');
      this.error = this.querySelector('.se-story__error');
      this.form.addEventListener('change', () => this.update(true), options);
      this.form.addEventListener('submit', event => this.add(event), options);
      this.slides = this.querySelector('.se-story__slides');
      if (this.slides) {
        const slides = [...this.slides.children];
        const thumbs = [...this.querySelectorAll('[data-slide]')];
        const position = index => Math.max(0, Math.min(this.slides.scrollWidth - this.slides.clientWidth, slides[index].offsetLeft - slides[0].offsetLeft));
        this.goToSlide = index => {
          const target = Math.max(0, Math.min(index, slides.length - 1));
          this.slides.scrollTo({left:position(target), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.updateGallery = () => {
          this.activeSlide = slides.reduce((best, slide, index) => Math.abs(position(index) - this.slides.scrollLeft) < Math.abs(position(best) - this.slides.scrollLeft) ? index : best, 0);
          thumbs.forEach(button => {const active = Number(button.dataset.slide) === this.activeSlide;button.classList.toggle('is-aktiv', active);button.setAttribute('aria-current', String(active));});
          this.querySelector('.mmb__fahne')?.classList.toggle('ist-weg', this.activeSlide !== 0);
        };
        thumbs.forEach(button => button.addEventListener('click', () => this.goToSlide(Number(button.dataset.slide)), options));
        this.slides.addEventListener('scroll', () => {cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.updateGallery);}, {...options, passive:true});
        this.slides.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          this.goToSlide(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : (this.activeSlide || 0) + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        window.addEventListener('resize', this.updateGallery, options);
        if (window.ResizeObserver) {this.resizeObserver = new ResizeObserver(this.updateGallery);this.resizeObserver.observe(this.slides);}
        this.updateGallery();
      }
      document.addEventListener('sender-story:selection', event => {
        if (event.detail.source === this || event.detail.product !== this.dataset.product) return;
        this.variant.value = event.detail.variant;
        const offer = this.offers.find(input => Number(input.value) === event.detail.quantity);
        if (offer) offer.checked = true;
        this.update(false);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.se-story__slide');
        if (slide && this.contains(slide)) this.goToSlide?.([...this.slides.children].indexOf(slide));
      }, options);
      if (this.dataset.mode === 'final') {
        const main = document.querySelector('sender-story-product[data-mode="main"]');
        const mainVariant = main?.querySelector('[name="id"]');
        const mainQuantity = main?.querySelector('[name="quantity"]:checked');
        if (mainVariant && [...this.variant.options].some(option => option.value === mainVariant.value)) this.variant.value = mainVariant.value;
        const offer = this.offers.find(input => input.value === mainQuantity?.value);
        if (offer) offer.checked = true;
      }
      this.update(false);
      const selected = this.offers.find(input => input.checked && !input.disabled);
      if (selected) document.dispatchEvent(new CustomEvent('sender-story:selection', {detail:{source:this,product:this.dataset.product,variant:this.variant.value,quantity:Number(selected.value),price:this.money(this.price(selected,this.variant.selectedOptions[0].dataset).total)}}));
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); cancelAnimationFrame(this.frame); }
    money(cents) { return new Intl.NumberFormat(this.dataset.locale || 'de', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(cents / 100); }
    merchandise(input, variant) {
      if (input?.dataset.bundleMode === 'true') {
        const data = input.dataset;
        return { id:data.bundleId, quantity:1, price:Number(data.bundlePrice), compare:Number(data.bundleCompare), available:data.bundleAvailable, unit:Number(data.bundleUnit), reference:data.bundleReference, min:Number(data.bundleMin), max:Number(data.bundleMax), step:Number(data.bundleStep) };
      }
      return { ...variant, id:this.variant.value, quantity:Number(input?.value || 1) };
    }
    price(input, variant) {
      if (input.dataset.bundleMode === 'true') {
        const item = this.merchandise(input, variant);
        return { each:Math.round(item.price / Number(input.value)), total:item.price, compare:Math.max(item.price,item.compare), unit:item.unit, reference:item.reference };
      }
      const price = Number(variant.price);
      const discount = Math.floor(price * Math.min(100, Math.max(0, Number(input.dataset.discount))) / 100);
      return { each: price - discount, total: (price - discount) * Number(input.value), compare: Math.max(price,Number(variant.compare)) * Number(input.value), unit: price ? Math.floor(Number(variant.unit) * (price-discount) / price) : 0, reference:variant.reference };
    }
    update(broadcast) {
      const option = this.variant.selectedOptions[0];
      if (!option) return;
      const variant = option.dataset;
      this.offers.forEach(input => {
        const item = this.merchandise(input, variant);
        const quantity = item.quantity;
        input.disabled = !item.id || item.available !== 'true' || quantity < Number(item.min) || (Number(item.max) > 0 && quantity > Number(item.max)) || (quantity - Number(item.min)) % Number(item.step) !== 0 || (input.dataset.bundleMode === 'true' && (!window.fetch || !window.FormData));
        const row = input.closest('.se-story__offer');
        row.classList.toggle('is-disabled', input.disabled);
        row.classList.toggle('sr-bundle__bar--selected',input.checked);
        const prices = this.price(input, variant);
        row.querySelector('[data-total]').textContent = this.money(prices.total);
        row.querySelector('[data-each]').textContent = this.money(prices.each);
        const compare = row.querySelector('[data-compare]');
        compare.textContent = this.money(prices.compare);
        compare.hidden = prices.compare <= prices.total;
      });
      let selected = this.offers.find(input => input.checked && !input.disabled);
      if (!selected) { selected = this.offers.find(input => !input.disabled); if (selected) selected.checked = true; }
      this.offers.forEach(input=>input.closest('.se-story__offer').classList.toggle('sr-bundle__bar--selected',input.checked));
      this.button.disabled = !selected || this.busy;
      this.button.querySelector('[data-button-label]').textContent = selected ? this.dataset.addLabel : this.dataset.soldLabel;
      const price = selected ? this.price(selected,variant) : {total:Number(variant.price),unit:Number(variant.unit)};
      this.querySelectorAll('[data-selected-total], [data-button-price]').forEach(el => el.textContent = this.money(price.total));
      const unit = this.querySelector('[data-selected-unit]');
      unit.textContent = price.unit && price.reference ? this.money(price.unit) + '/' + price.reference.replace(/^1(?=[a-z])/i,'') : '';
      const availability = this.querySelector('[data-availability]');
      if (availability) availability.textContent = selected ? this.dataset.stockLabel : this.dataset.soldLabel;
      if (broadcast) {
        const detail = {source:this,product:this.dataset.product,variant:this.variant.value,quantity:Number(selected?.value || this.offers.find(input => input.checked)?.value || 1),price:this.money(price.total)};
        document.dispatchEvent(new CustomEvent('sender-story:selection',{detail}));
        if (this.dataset.product === this.dataset.pageProduct) {
          const url = new URL(location.href); url.searchParams.set('variant',this.variant.value); history.replaceState({},'',url);
        }
      }
    }
    async add(event) {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (this.busy || this.button.disabled) return;
      this.busy = true; this.button.disabled = true; this.button.setAttribute('aria-busy','true'); this.error.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      const selected = this.offers.find(input => input.checked);
      const item = this.merchandise(selected, this.variant.selectedOptions[0].dataset);
      const data = new FormData(this.form);
      data.set('id', item.id);
      data.set('quantity', String(item.quantity));
      const eventClass = window.StandardEvents?.CartLinesUpdateEvent;
      let deferred;
      if (eventClass) {
        try {
          deferred = eventClass.createPromise();
          this.dispatchEvent(new eventClass({action:'add',context:'product',lines:[{merchandiseId:item.id,quantity:item.quantity}],promise:deferred.promise}));
        } catch { deferred = null; }
      }
      const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
      if (sections.length) {data.append('sections',sections.join(','));data.append('sections_url',location.pathname); drawer.setActiveElement?.(event.submitter || this.button);}
      let added = false;
      try {
        const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        let result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        added = true;
        if (deferred) {
          fetch(this.dataset.cartUrl + '.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cart=>deferred.resolve({cart:eventClass.createCartFromAjaxResponse(cart)})).catch(error=>deferred.reject(error));
        }
        if (selected?.dataset.code && selected.dataset.bundleMode !== 'true') {
          const discountResponse = await fetch(this.dataset.updateUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:selected.dataset.code,sections,sections_url:location.pathname})});
          const updated = await discountResponse.json();
          if (!discountResponse.ok || updated.status) {location.assign(this.dataset.cartUrl);return;}
          result = updated;
        }
        if (drawer && sections.every(id => result.sections?.[id])) {
          drawer.classList.remove('is-empty'); drawer.renderContents(result);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            fetch(this.dataset.cartUrl + '.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cartData=>publish(PUB_SUB_EVENTS.cartUpdate,{source:'sender-story',productVariantId:item.id,cartData})).catch(()=>{});
          }
        } else location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (added) {location.assign(this.dataset.cartUrl);return;}
        deferred?.reject(error);
        const CartError = window.StandardEvents?.CartErrorEvent;
        if (CartError) this.dispatchEvent(new CartError({error:error.message || this.dataset.error,code:'INVALID'}));
        this.error.textContent = error.message || this.dataset.error; this.error.hidden = false;
      } finally {
        this.busy = false; this.button.removeAttribute('aria-busy'); this.update(false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sender-story-promo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sender-story-promo')) customElements.define('sender-story-promo', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    clearInterval(this.timer);
    this.controller = new AbortController();
    this.counter = this.querySelector('[data-uhr]');
    this.caption = this.querySelector('[data-deadline-label]');
    this.text = this.querySelector('.mmt__text');
    if (!this.counter || !this.caption || !this.text) return;
    this.digits = ['std', 'min', 'sek'].map(key => this.counter.querySelector('[data-' + key + ']'));
    this.originalText ??= this.text.textContent;
    this.text.textContent = this.originalText;
    this.daily = this.dataset.mode === 'daily';
    this.zone = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Berlin', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'});
    this.dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'de', {timeZone:'Europe/Berlin', day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit', hourCycle:'h23'});
    this.deadline = this.daily ? this.nextMidnight(Date.now()) : Date.parse(this.dataset.deadline);
    this.caption.removeAttribute('datetime');
    this.tick = () => {
      const now = Date.now();
      if (this.daily && now >= this.deadline) this.deadline = this.nextMidnight(now);
      if (!Number.isFinite(this.deadline)) {
        this.counter.hidden = true;
        this.caption.hidden = true;
        clearInterval(this.timer);
        return;
      }
      const left = Math.max(0, Math.ceil((this.deadline - now) / 1000));
      if (!left) {
        this.counter.hidden = true;
        this.caption.hidden = true;
        this.text.textContent = this.dataset.expired;
        clearInterval(this.timer);
        return;
      }
      this.counter.hidden = false;
      this.caption.hidden = false;
      const values = [Math.floor(left / 3600), Math.floor(left / 60) % 60, left % 60];
      this.digits.forEach((digit, index) => { digit.textContent = String(values[index]).padStart(2, '0'); });
      const iso = new Date(this.deadline).toISOString();
      if (this.caption.dateTime !== iso) {
        this.caption.dateTime = iso;
        this.caption.textContent = [this.caption.dataset.label, this.dateFormat.format(this.deadline)].filter(Boolean).join(' ');
      }
    };
    if (Number.isFinite(this.deadline)) this.timer = setInterval(this.tick, 1000);
    this.tick();
    document.addEventListener('visibilitychange', this.tick, {signal:this.controller.signal});
    window.addEventListener('pageshow', this.tick, {signal:this.controller.signal});
  }
  parts(time) {
    return Object.fromEntries(this.zone.formatToParts(time).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  }
  nextMidnight(now) {
    const date = this.parts(now);
    const target = Date.UTC(date.year, date.month - 1, date.day + 1);
    let result = target;
    for (let index = 0; index < 4; index++) {
      const local = this.parts(result);
      const correction = target - Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
      result += correction;
      if (correction === 0) break;
    }
    return result;
  }
  disconnectedCallback() {
    clearInterval(this.timer);
    this.controller?.abort();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sender-story-sticky"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sender-story-sticky')) customElements.define('sender-story-sticky', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    this.button = this.querySelector('[data-hoch]');
    this.label = this.querySelector('[data-sticky-label]');
    this.price = this.querySelector('[data-sticky-price]');
    this.error = this.querySelector('[data-sticky-error]');
    this.main = document.querySelector('.se-story-product--main sender-story-product');
    this.form = this.main?.querySelector('form');
    this.mainButton = this.form?.querySelector('[type="submit"]');
    this.directAdd = this.dataset.action === 'add';
    if (this.directAdd && this.form?.getAttribute('id')) {
      this.button.type = 'submit';
      this.button.setAttribute('form', this.form.getAttribute('id'));
    }
    this.sync = () => {
      if (!this.directAdd) return;
      const busy = this.mainButton?.getAttribute('aria-busy') === 'true';
      const disabled = !this.mainButton || this.mainButton.disabled;
      this.button.disabled = disabled;
      this.button.classList.toggle('is-busy', busy);
      this.button.setAttribute('aria-busy', String(busy));
      this.label.textContent = busy ? this.dataset.addingLabel : disabled ? (this.mainButton?.querySelector('[data-button-label]')?.textContent || this.dataset.label) : this.dataset.label;
      if (this.price) this.price.textContent = this.mainButton?.querySelector('[data-button-price]')?.textContent || '';
      const error = this.main?.querySelector('.se-story__error');
      this.error.hidden = !error || error.hidden || !error.textContent;
      this.error.textContent = this.error.hidden ? '' : error.textContent;
    };
    this.button.addEventListener('click', event => {
      event.preventDefault();
      if (this.directAdd && this.form && this.mainButton && !this.mainButton.disabled) {
        this.form.requestSubmit(this.button);
      } else if (!this.directAdd) {
        this.form?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block:'center'});
      }
    }, options);
    if (this.directAdd && this.main) {
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-busy','hidden']});
    }
    this.update = () => {
      const main = document.querySelector('.se-story-product--main');
      if (!main) {this.hidden = true; return;}
      const mainVisible = main.getBoundingClientRect().bottom > 120;
      const final = document.querySelector('.se-story-product--final');
      const rect = final?.getBoundingClientRect();
      this.hidden = mainVisible || Boolean(rect && rect.top < innerHeight && rect.bottom > 0);
    };
    document.addEventListener('scroll', () => {cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.update);}, {...options, passive:true});
    window.addEventListener('resize', this.update, options);
    document.addEventListener('sender-story:selection', this.sync, options);
    document.addEventListener('shopify:section:load', this.update, options);
    document.addEventListener('shopify:section:unload', this.update, options);
    this.sync();
    this.update();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
  }
});

  } catch(e) { console.error(e); }
})();
})();
